module.exports = __webpack_public_path__ + "static/img/jx-ylm82.1c8086a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-ylm82.png
// module id = N6Xq
// module chunks = 0